import React, {useState} from "react";
import {PlacedOrderProduct, PlacedOrderProductOption, productPlaceholderImgSrc} from "@/data/entities/product";
import {twJoin} from "tailwind-merge";
import {formatMoney} from "@/utils/MoneyUtils";
import {Badge} from "peggirkit";
import {FormattedMessage} from "react-intl";

type Props = {
    product: PlacedOrderProduct,
};

const Product = ({product: {count, name, image, price, options, redeemedLoyaltyPoints}}: Props) => {
    const [loadingImage, setLoadingImage] = useState(true);
    const [imgSrc, setImgSrc] = useState(image ?? productPlaceholderImgSrc);

    return (
        <article
            aria-label={name}
            className={"w-full flex flex-row gap-3 items-start justify-start"}
        >
            <img
                alt={name}
                width="80"
                height="80"
                className={twJoin(
                    "w-[80px] h-[80px] object-cover rounded-xl shrink-0 grow-0 bg-black/10 dark:bg-white/10",
                    loadingImage ? "animate-pulse" : "",
                )}
                src={imgSrc}
                onError={() => {
                    setLoadingImage(false);
                    setImgSrc(productPlaceholderImgSrc)
                }}
                onLoad={() => setLoadingImage(false)}
            />

            <div className={"w-full flex flex-col"}>
                <div className={"w-full flex items-start justify-between gap-3 font-medium"}>
                    <h3>
                        {count}{"x "}{name}
                    </h3>

                    <div className={"flex flex-col items-end justify-start"}>
                        <data className={redeemedLoyaltyPoints === null ? "" : "line-through"}>
                            {formatMoney(price)}
                        </data>

                        {
                            redeemedLoyaltyPoints !== null &&
                            <Badge
                                color={"success"}
                                size={"xs"}
                                containerClassname={"mb-2"}
                            >
                                <FormattedMessage
                                    id={"n-points"}
                                    values={{n: redeemedLoyaltyPoints}}
                                />
                            </Badge>
                        }
                    </div>
                </div>

                <ul className={"flex flex-col text-[90%] text-gray-600 dark:text-gray-400"}>
                    {options.map((o: PlacedOrderProductOption, i) =>
                        <li
                            key={i}
                            className={"w-full flex items-start justify-between gap-3"}
                        >
                            <p>
                                {"+ "}{o.name}
                            </p>

                            <data>
                                {formatMoney(o.price)}
                            </data>
                        </li>
                    )}
                </ul>
            </div>
        </article>
    );
};

export default Product;